import React from "react";
import CancelIcon from "@material-ui/icons/Cancel";
import { NOTIFICATION_ORGANIZATION_TYPES } from "../../../SuperAdmin/pages/notification/NotificationUIHelpers";

export default function NotificationDashboard({
  notifications = [],
  onCloseNotification
}) {
  return (
    <>
      {notifications.map(item => (
        <div
          className={`bg-${
            item.type !== NOTIFICATION_ORGANIZATION_TYPES.DEFAULT
              ? item.type.toLowerCase()
              : "white"
          } rounded p-8 my-4 d-flex`}
        >
          <div className="w-100">
            <span
              className={`${
                item.type !== NOTIFICATION_ORGANIZATION_TYPES.DEFAULT
                  ? "text-white"
                  : "text-dark"
              } font-weight-bolder line-height-lg`}
            >
              {item.message}
            </span>
          </div>
          <div
            className="flex-shrink-1"
            onClick={() => onCloseNotification(item)}
          >
            <CancelIcon className="cursor-pointer" style={{ color: "#FFF" }} />
          </div>
        </div>
      ))}
    </>
  );
}
